import React from 'react';
import ReactDOM from 'react-dom';
import ga from 'react-ga';
import Raven from 'raven-js';
import fastclick from 'fastclick';
import grabStorage from 'grab-storage';
import _ from 'lodash';

import { Provider } from 'react-redux';
import { syncHistoryWithStore } from 'react-router-redux';
import {
  Router,
  useRouterHistory,
} from 'react-router';
/* eslint-disable import/no-unresolved, import/no-extraneous-dependencies, import/extensions */
import { createHistory } from 'history';
// history is imported by react-router.
import configureStore from 'stores/configure-store';

import Config, { loadConfig } from 'config';
import routes from 'routes';

import 'global.scss';

function initApp() {
  // GA
  ga.initialize(Config.GA_KEY, {
    debug: grabStorage.reactGa === 'true',
    titleCase: false,
  });

  const reduxStateStorageKey = 'reduxState';
  const persistedState = JSON.parse(grabStorage.getItem(reduxStateStorageKey)) || {};
  const store = configureStore(persistedState);
  store.subscribe(_.throttle(() => {
    const storeState = store.getState();
    // TODO: Possibly write our own utility pickNestedKeys function to
    //       pick out the keys (including nested keys) from the store
    //       that we want to persist.
    grabStorage.setItem(reduxStateStorageKey, JSON.stringify({
      library: {
        passengers: storeState.library.passengers,
        drivers: storeState.library.drivers,
        merchants: storeState.library.merchants,
        bookings: storeState.library.bookings,
      },
      app: {
        activeCohortID: storeState.app.activeCohortID,
        user: storeState.app.user,
      },
    }));
  }, 1000));

  // Mobile Click Support
  fastclick.attach(document.body);

  // Get Sentry
  if (process.env.NODE_ENV === 'production') {
    Raven.config(Config.SENTRY_DSN, {
      release: Config.APP_VERSION,
    }).install();
  }

  // Route Settings
  function routeChange() {
    document.body.scrollTop = 0;
    ga.pageview(window.location.pathname);
  }

  const history = syncHistoryWithStore(useRouterHistory(createHistory)({
    basename: '/',
  }), store);

  ReactDOM.render((
    <Provider store={store}>
      <Router history={history} onUpdate={routeChange}>
        {routes(store)}
      </Router>
    </Provider>), document.getElementById('app')
  );
}

window.fetch(require('config.json'))
  .then((configResponse) => {
    if (configResponse.status !== 200) {
      return;
    }
    configResponse.json().then((config) => {
      loadConfig(config);
      initApp();
    });
  })
  .catch((err) => {
    Raven.captureException(err);
  });



/** WEBPACK FOOTER **
 ** ./src/js/index.jsx
 **/